function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLogoTacc(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: "400px",
    height: "400px",
    style: {
      shapeRendering: "geometricPrecision",
      textRendering: "geometricPrecision",
      imageRendering: "optimizeQuality",
      fillRule: "evenodd",
      clipRule: "evenodd"
    },
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.042
    },
    fill: "#1f2732",
    d: "M 165.5,-0.5 C 181.167,-0.5 196.833,-0.5 212.5,-0.5C 212.5,0.166667 212.167,0.5 211.5,0.5C 210.833,0.5 210.5,0.833333 210.5,1.5C 210.068,2.70951 209.401,3.70951 208.5,4.5C 208.167,3.16667 207.833,3.16667 207.5,4.5C 206.167,4.83333 206.167,5.16667 207.5,5.5C 206.833,6.83333 205.833,7.83333 204.5,8.5C 203.833,8.5 203.5,8.83333 203.5,9.5C 201.071,14.0249 198.905,18.6915 197,23.5C 196.112,29.1561 195.279,34.8227 194.5,40.5C 189.565,39.5524 184.565,39.219 179.5,39.5C 179.206,43.0998 178.54,46.5998 177.5,50C 163.351,51.6267 149.684,55.1267 136.5,60.5C 135.14,59.8201 133.807,59.1534 132.5,58.5C 131.713,56.8958 130.38,56.2291 128.5,56.5C 127.292,55.7659 125.959,55.4326 124.5,55.5C 123.817,53.8235 122.483,53.1568 120.5,53.5C 120.158,52.6618 119.492,52.3284 118.5,52.5C 115.941,52.1984 113.607,52.5318 111.5,53.5C 110.976,55.3057 110.309,56.9724 109.5,58.5C 109.167,57.1667 108.833,57.1667 108.5,58.5C 108.042,64.9157 107.042,71.249 105.5,77.5C 98.3965,82.4337 91.7298,87.9337 85.5,94C 79.4583,100.373 73.7916,107.04 68.5,114C 66.0995,114.186 63.7662,114.686 61.5,115.5C 60.3451,120.095 59.5118,124.762 59,129.5C 54.8834,137.342 51.0501,145.342 47.5,153.5C 45.4295,159.005 44.0961,164.672 43.5,170.5C 41.631,172.635 40.9644,175.302 41.5,178.5C 40.3385,194.661 40.1718,210.995 41,227.5C 41.1909,229.708 41.6909,231.708 42.5,233.5C 58.3965,295.23 96.8965,335.23 158,353.5C 178.228,358.392 198.728,359.725 219.5,357.5C 225.069,357.624 230.402,356.957 235.5,355.5C 292.432,341.242 332.099,306.909 354.5,252.5C 356.797,244.604 358.464,236.604 359.5,228.5C 360.117,228.389 360.617,228.056 361,227.5C 361.828,210.995 361.662,194.661 360.5,178.5C 360.663,176.143 360.497,173.81 360,171.5C 359.617,170.944 359.117,170.611 358.5,170.5C 349.057,130.155 327.057,98.3215 292.5,75C 283.185,69.4273 273.685,64.2606 264,59.5C 263.423,50.4502 261.256,41.7835 257.5,33.5C 252.331,34.9188 246.997,35.9188 241.5,36.5C 241.098,32.0876 240.265,27.7543 239,23.5C 236.563,19.6008 234.396,15.6008 232.5,11.5C 232.5,10.8333 232.167,10.5 231.5,10.5C 229.5,9.16667 227.833,7.5 226.5,5.5C 226.5,4.83333 226.167,4.5 225.5,4.5C 225.167,3.16667 224.833,3.16667 224.5,4.5C 222.887,3.30766 221.22,2.30766 219.5,1.5C 222.167,1.16667 222.167,0.833333 219.5,0.5C 218.508,0.67158 217.842,0.338246 217.5,-0.5C 234.167,-0.5 250.833,-0.5 267.5,-0.5C 270.23,2.71269 273.23,5.71269 276.5,8.5C 276.291,9.08605 275.957,9.58605 275.5,10C 279.414,13.2308 283.08,16.7308 286.5,20.5C 290.193,26.3601 294.859,31.3601 300.5,35.5C 300.977,36.931 301.643,38.2643 302.5,39.5C 311.202,46.8027 320.535,53.3027 330.5,59C 338.223,67.0588 346.223,74.7254 354.5,82C 354.043,82.414 353.709,82.914 353.5,83.5C 355.197,84.3636 356.363,85.6969 357,87.5C 357.333,87.1667 357.667,86.8333 358,86.5C 360.85,90.7117 363.517,95.045 366,99.5C 367.667,101.545 369.5,103.378 371.5,105C 371.043,105.414 370.709,105.914 370.5,106.5C 377.041,114.425 381.541,123.092 384,132.5C 384.333,132.167 384.667,131.833 385,131.5C 385.116,134.932 386.283,137.932 388.5,140.5C 391.684,153.508 395.017,166.341 398.5,179C 397.869,180.906 397.536,182.906 397.5,185C 397.547,187.295 398.213,189.129 399.5,190.5C 399.5,201.5 399.5,212.5 399.5,223.5C 398.213,224.871 397.547,226.705 397.5,229C 397.536,231.094 397.869,233.094 398.5,235C 395.599,247.799 392.266,260.633 388.5,273.5C 386.304,279.48 383.637,284.813 380.5,289.5C 380.709,290.086 381.043,290.586 381.5,291C 377.957,296.586 374.291,302.086 370.5,307.5C 370.709,308.086 371.043,308.586 371.5,309C 368.833,312 366.167,315 363.5,318C 363.957,318.414 364.291,318.914 364.5,319.5C 360.773,323.06 357.606,327.06 355,331.5C 352.333,333.5 350,335.833 348,338.5C 346.334,337.66 346.167,338.16 347.5,340C 337.498,348.345 327.498,356.679 317.5,365C 306.432,371.152 295.266,377.318 284,383.5C 283.586,383.043 283.086,382.709 282.5,382.5C 272.726,387.091 262.726,391.091 252.5,394.5C 251.554,394.013 250.554,393.68 249.5,393.5C 240.43,395.687 231.43,397.687 222.5,399.5C 207.167,399.5 191.833,399.5 176.5,399.5C 167.57,397.687 158.57,395.687 149.5,393.5C 148.446,393.68 147.446,394.013 146.5,394.5C 136.274,391.091 126.274,387.091 116.5,382.5C 115.914,382.709 115.414,383.043 115,383.5C 103.734,377.318 92.5678,371.152 81.5,365C 72.2322,358.073 63.2322,350.739 54.5,343C 53.8333,341.667 52.8333,340.667 51.5,340C 52.8331,338.16 52.6665,337.66 51,338.5C 49,335.833 46.6667,333.5 44,331.5C 41.3938,327.06 38.2271,323.06 34.5,319.5C 34.7093,318.914 35.0426,318.414 35.5,318C 32.5676,314.944 29.7342,311.777 27,308.5C 24.7213,302.104 21.5546,296.271 17.5,291C 17.9574,290.586 18.2907,290.086 18.5,289.5C 15.3627,284.813 12.696,279.48 10.5,273.5C 7.13148,261.101 3.79815,248.768 0.5,236.5C 1.10738,234.225 1.44071,231.891 1.5,229.5C 1.46093,227.048 0.794259,225.048 -0.5,223.5C -0.5,212.5 -0.5,201.5 -0.5,190.5C 0.786832,189.129 1.4535,187.295 1.5,185C 1.46442,182.906 1.13109,180.906 0.5,179C 2.54572,170.987 4.54572,162.821 6.5,154.5C 12.7908,132.606 21.9575,112.273 34,93.5C 43.2846,83.7146 52.7846,74.0479 62.5,64.5C 62.2907,63.914 61.9574,63.414 61.5,63C 65.3144,58.3513 69.3144,53.8513 73.5,49.5C 74.0983,48.2054 74.5983,46.8721 75,45.5C 75.3333,45.8333 75.6667,46.1667 76,46.5C 83.8418,35.8141 94.3418,28.9807 107.5,26C 116.112,24.1804 124.778,22.6804 133.5,21.5C 135.32,21.3507 136.82,20.6841 138,19.5C 138.725,20.0585 139.558,20.3918 140.5,20.5C 144.141,19.3204 147.474,17.6537 150.5,15.5C 151.086,15.7093 151.586,16.0426 152,16.5C 155.667,13.5 159,10.1667 162,6.5C 163.726,4.40883 164.893,2.0755 165.5,-0.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.987
    },
    fill: "#f8f4f4",
    d: "M 212.5,-0.5 C 214.167,-0.5 215.833,-0.5 217.5,-0.5C 217.842,0.338246 218.508,0.67158 219.5,0.5C 219.5,0.833333 219.5,1.16667 219.5,1.5C 221.22,2.30766 222.887,3.30766 224.5,4.5C 224.833,4.5 225.167,4.5 225.5,4.5C 226.167,4.5 226.5,4.83333 226.5,5.5C 227.833,7.5 229.5,9.16667 231.5,10.5C 232.167,10.5 232.5,10.8333 232.5,11.5C 234.396,15.6008 236.563,19.6008 239,23.5C 240.265,27.7543 241.098,32.0876 241.5,36.5C 246.997,35.9188 252.331,34.9188 257.5,33.5C 261.256,41.7835 263.423,50.4502 264,59.5C 273.685,64.2606 283.185,69.4273 292.5,75C 327.057,98.3215 349.057,130.155 358.5,170.5C 358.963,173.33 359.629,175.997 360.5,178.5C 360.805,195.214 360.471,211.881 359.5,228.5C 358.464,236.604 356.797,244.604 354.5,252.5C 332.099,306.909 292.432,341.242 235.5,355.5C 229.949,355.527 224.616,356.194 219.5,357.5C 198.728,359.725 178.228,358.392 158,353.5C 96.8965,335.23 58.3965,295.23 42.5,233.5C 41.5976,215.185 41.2643,196.852 41.5,178.5C 42.3705,175.997 43.0372,173.33 43.5,170.5C 44.0961,164.672 45.4295,159.005 47.5,153.5C 51.0501,145.342 54.8834,137.342 59,129.5C 59.5118,124.762 60.3451,120.095 61.5,115.5C 63.7662,114.686 66.0995,114.186 68.5,114C 73.7916,107.04 79.4583,100.373 85.5,94C 91.7298,87.9337 98.3965,82.4337 105.5,77.5C 107.042,71.249 108.042,64.9157 108.5,58.5C 108.833,58.5 109.167,58.5 109.5,58.5C 110.309,56.9724 110.976,55.3057 111.5,53.5C 115.928,53.7988 120.261,54.4654 124.5,55.5C 125.959,55.4326 127.292,55.7659 128.5,56.5C 129.514,57.6737 130.847,58.3404 132.5,58.5C 133.807,59.1534 135.14,59.8201 136.5,60.5C 149.684,55.1267 163.351,51.6267 177.5,50C 178.54,46.5998 179.206,43.0998 179.5,39.5C 184.565,39.219 189.565,39.5524 194.5,40.5C 195.279,34.8227 196.112,29.1561 197,23.5C 198.905,18.6915 201.071,14.0249 203.5,9.5C 204.167,9.5 204.5,9.16667 204.5,8.5C 205.833,7.83333 206.833,6.83333 207.5,5.5C 207.5,5.16667 207.5,4.83333 207.5,4.5C 207.833,4.5 208.167,4.5 208.5,4.5C 209.401,3.70951 210.068,2.70951 210.5,1.5C 211.167,1.5 211.5,1.16667 211.5,0.5C 212.167,0.5 212.5,0.166667 212.5,-0.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#5a5451",
    d: "M 230.5,27.5 C 232.067,28.6808 232.901,30.3474 233,32.5C 233.208,38.6937 233.375,44.6937 233.5,50.5C 232.86,52.332 231.86,52.6653 230.5,51.5C 231.802,43.5004 231.802,35.5004 230.5,27.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#75706d",
    d: "M 252.5,43.5 C 247.776,44.6304 243.109,45.9637 238.5,47.5C 241.403,45.3523 244.736,43.8523 248.5,43C 250.066,42.235 251.399,42.4017 252.5,43.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.216
    },
    fill: "#92959b",
    d: "M 111.5,53.5 C 113.607,52.5318 115.941,52.1984 118.5,52.5C 118.842,53.3382 119.508,53.6716 120.5,53.5C 122.483,53.1568 123.817,53.8235 124.5,55.5C 120.261,54.4654 115.928,53.7988 111.5,53.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#4d4744",
    d: "M 197.5,49.5 C 194.421,49.7399 191.421,49.4066 188.5,48.5C 187.832,51.3056 187.166,53.9723 186.5,56.5C 186.5,53.5 186.5,50.5 186.5,47.5C 190.387,47.6459 194.054,48.3126 197.5,49.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.208
    },
    fill: "#8d9196",
    d: "M 128.5,56.5 C 130.38,56.2291 131.713,56.8958 132.5,58.5C 130.847,58.3404 129.514,57.6737 128.5,56.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#ea3337",
    d: "M 186.5,57.5 C 187.387,65.4962 190.054,72.8295 194.5,79.5C 192.955,80.4519 191.288,80.7852 189.5,80.5C 189.313,86.2124 189.646,91.8791 190.5,97.5C 185.432,97.2449 180.766,98.2449 176.5,100.5C 175.167,100.5 173.833,100.5 172.5,100.5C 172.678,96.8776 172.011,93.5443 170.5,90.5C 168.953,85.7526 166.286,81.5859 162.5,78C 161.167,77.3333 159.833,77.3333 158.5,78C 154.275,81.7218 150.608,85.8885 147.5,90.5C 146.648,88.0758 145.648,85.7424 144.5,83.5C 144.573,81.9731 143.906,80.9731 142.5,80.5C 140.971,76.6319 138.637,73.2985 135.5,70.5C 142.576,67.2272 149.91,64.5606 157.5,62.5C 160.152,62.5905 162.485,61.9238 164.5,60.5C 171.649,58.4208 178.982,57.4208 186.5,57.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#f36f70",
    d: "M 164.5,60.5 C 162.485,61.9238 160.152,62.5905 157.5,62.5C 159.515,61.0762 161.848,60.4095 164.5,60.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#8c8785",
    d: "M 117.5,62.5 C 117.741,64.8984 117.074,66.8984 115.5,68.5C 115.259,66.1016 115.926,64.1016 117.5,62.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#ec3337",
    d: "M 253.5,65.5 C 304.377,84.3757 336.71,120.042 350.5,172.5C 350.116,176.489 350.783,180.155 352.5,183.5C 353.772,196.477 353.772,209.477 352.5,222.5C 350.77,226.883 349.77,231.55 349.5,236.5C 348.659,238.379 348.325,240.379 348.5,242.5C 346.787,243.635 346.12,245.302 346.5,247.5C 345.388,249.599 344.721,251.933 344.5,254.5C 343.094,254.973 342.427,255.973 342.5,257.5C 340.616,260.603 339.282,263.937 338.5,267.5C 337.094,267.973 336.427,268.973 336.5,270.5C 315.974,307.023 285.64,331.357 245.5,343.5C 242.99,343.927 240.657,344.593 238.5,345.5C 235.848,345.41 233.515,346.076 231.5,347.5C 230.5,347.5 229.5,347.5 228.5,347.5C 222.845,348.249 217.178,348.915 211.5,349.5C 200.482,349.619 189.482,349.286 178.5,348.5C 171.975,347.929 165.641,346.595 159.5,344.5C 157.485,343.076 155.152,342.41 152.5,342.5C 100.747,325.08 67.414,290.08 52.5,237.5C 52.5905,234.848 51.9238,232.515 50.5,230.5C 48.778,216.901 48.1113,203.234 48.5,189.5C 49.5249,186.026 50.1916,182.36 50.5,178.5C 50.5,178.167 50.5,177.833 50.5,177.5C 51.9238,175.485 52.5905,173.152 52.5,170.5C 53.01,167.461 53.6766,164.461 54.5,161.5C 56.2027,155.997 58.2027,150.664 60.5,145.5C 62.2451,143.967 63.2451,141.967 63.5,139.5C 64.1695,136.151 65.8361,133.484 68.5,131.5C 70.2647,140.364 74.598,147.698 81.5,153.5C 80.9002,154.9 79.9002,155.9 78.5,156.5C 73.8494,157.008 71.0161,159.341 70,163.5C 74.6958,170.932 81.1958,176.099 89.5,179C 88.4258,179.739 87.7591,180.739 87.5,182C 89.4211,184.404 91.0877,186.904 92.5,189.5C 91.596,190.209 91.2627,191.209 91.5,192.5C 90.5084,199.648 90.175,206.981 90.5,214.5C 91.791,214.737 92.791,214.404 93.5,213.5C 94.391,212.89 95.391,212.557 96.5,212.5C 100.015,211.081 103.681,210.414 107.5,210.5C 107.354,208.058 108.187,207.391 110,208.5C 111.085,207.264 111.918,205.931 112.5,204.5C 115.204,202.829 117.871,201.163 120.5,199.5C 122.5,198.833 124.5,198.167 126.5,197.5C 128.679,196.941 130.846,196.274 133,195.5C 133.772,195.645 134.439,195.978 135,196.5C 136.653,193.75 139.153,191.416 142.5,189.5C 142.5,189.167 142.5,188.833 142.5,188.5C 147.098,187.535 151.098,185.535 154.5,182.5C 157.442,181.696 160.109,180.362 162.5,178.5C 168.587,176.622 174.254,173.955 179.5,170.5C 181.027,170.573 182.027,169.906 182.5,168.5C 187.958,166.565 193.291,164.232 198.5,161.5C 200.05,160.559 201.716,159.893 203.5,159.5C 205.027,159.573 206.027,158.906 206.5,157.5C 208.875,156.098 211.209,154.765 213.5,153.5C 215.784,153.025 217.784,152.025 219.5,150.5C 221.954,149.773 224.287,148.773 226.5,147.5C 227.833,146.833 229.167,146.167 230.5,145.5C 237.838,141.831 245.171,138.164 252.5,134.5C 254.483,133.529 256.483,132.529 258.5,131.5C 264.66,128.887 270.66,125.887 276.5,122.5C 271.067,118.387 265.401,114.72 259.5,111.5C 259.167,111.5 258.833,111.5 258.5,111.5C 258.461,110.417 258.127,109.417 257.5,108.5C 255.833,107.833 254.167,107.167 252.5,106.5C 252.994,104.974 253.661,103.641 254.5,102.5C 255.924,100.485 256.59,98.1522 256.5,95.5C 256.5,95.1667 256.5,94.8333 256.5,94.5C 257.647,90.3537 257.814,86.0204 257,81.5C 256.963,79.0261 256.13,77.0261 254.5,75.5C 253.328,74.2947 251.995,74.2947 250.5,75.5C 249.702,75.0431 249.369,74.3764 249.5,73.5C 250.323,70.5198 251.657,67.8531 253.5,65.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#60221f",
    d: "M 249.5,73.5 C 249.369,74.3764 249.702,75.0431 250.5,75.5C 251.995,74.2947 253.328,74.2947 254.5,75.5C 252.565,76.1495 250.565,76.4828 248.5,76.5C 248.263,75.209 248.596,74.209 249.5,73.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#e83236",
    d: "M 115.5,81.5 C 117.019,89.032 120.685,95.3653 126.5,100.5C 124.143,102.098 121.477,103.098 118.5,103.5C 115.14,103.616 111.807,103.949 108.5,104.5C 108.846,108.377 110.012,112.043 112,115.5C 115.697,120.362 119.864,124.696 124.5,128.5C 122.167,130.167 120.167,132.167 118.5,134.5C 115.763,131.598 112.596,129.265 109,127.5C 107.395,128.101 106.062,129.101 105,130.5C 103.031,134.144 100.864,137.477 98.5,140.5C 95.0146,133.516 89.6812,128.349 82.5,125C 79.3718,124.159 76.3718,123.325 73.5,122.5C 84.8764,106.123 98.8764,92.4567 115.5,81.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#5d211f",
    d: "M 254.5,75.5 C 256.13,77.0261 256.963,79.0261 257,81.5C 257.814,86.0204 257.647,90.3537 256.5,94.5C 256.768,88.0463 256.102,81.7129 254.5,75.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#802524",
    d: "M 256.5,95.5 C 256.59,98.1522 255.924,100.485 254.5,102.5C 254.41,99.8478 255.076,97.5145 256.5,95.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#59201e",
    d: "M 126.5,100.5 C 127.404,101.209 127.737,102.209 127.5,103.5C 124.5,103.5 121.5,103.5 118.5,103.5C 121.477,103.098 124.143,102.098 126.5,100.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#fbf3f3",
    d: "M 259.5,111.5 C 265.401,114.72 271.067,118.387 276.5,122.5C 270.66,125.887 264.66,128.887 258.5,131.5C 258.263,130.209 258.596,129.209 259.5,128.5C 260.711,122.977 260.711,117.31 259.5,111.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#f1d307",
    d: "M 252.5,131.5 C 252.5,132.5 252.5,133.5 252.5,134.5C 245.171,138.164 237.838,141.831 230.5,145.5C 230.5,142.833 230.5,140.167 230.5,137.5C 231.924,135.485 232.59,133.152 232.5,130.5C 235.855,123.812 240.855,118.812 247.5,115.5C 249.441,115.131 251.275,114.464 253,113.5C 253.409,119.51 253.242,125.51 252.5,131.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#6e6866",
    d: "M 258.5,111.5 C 258.833,111.5 259.167,111.5 259.5,111.5C 260.711,117.31 260.711,122.977 259.5,128.5C 259.625,122.797 259.292,117.13 258.5,111.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#f0d20a",
    d: "M 203.5,118.5 C 210.363,120.425 216.029,124.091 220.5,129.5C 220.427,131.027 221.094,132.027 222.5,132.5C 225.838,136.842 227.171,141.842 226.5,147.5C 224.287,148.773 221.954,149.773 219.5,150.5C 207.795,145.816 200.795,137.15 198.5,124.5C 198.337,122.143 198.503,119.81 199,117.5C 200.356,118.38 201.856,118.714 203.5,118.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#241c18",
    d: "M 230.5,27.5 C 231.802,35.5004 231.802,43.5004 230.5,51.5C 231.86,52.6653 232.86,52.332 233.5,50.5C 234.922,49.075 236.589,48.075 238.5,47.5C 243.109,45.9637 247.776,44.6304 252.5,43.5C 254.809,50.6033 255.143,57.9366 253.5,65.5C 251.657,67.8531 250.323,70.5198 249.5,73.5C 248.596,74.209 248.263,75.209 248.5,76.5C 250.565,76.4828 252.565,76.1495 254.5,75.5C 256.102,81.7129 256.768,88.0463 256.5,94.5C 256.5,94.8333 256.5,95.1667 256.5,95.5C 255.076,97.5145 254.41,99.8478 254.5,102.5C 253.661,103.641 252.994,104.974 252.5,106.5C 254.167,107.167 255.833,107.833 257.5,108.5C 258.127,109.417 258.461,110.417 258.5,111.5C 259.292,117.13 259.625,122.797 259.5,128.5C 258.596,129.209 258.263,130.209 258.5,131.5C 256.483,132.529 254.483,133.529 252.5,134.5C 252.5,133.5 252.5,132.5 252.5,131.5C 254.177,125.416 254.844,119.082 254.5,112.5C 251.654,112.552 249.32,113.552 247.5,115.5C 240.855,118.812 235.855,123.812 232.5,130.5C 231.076,132.515 230.41,134.848 230.5,137.5C 230.5,140.167 230.5,142.833 230.5,145.5C 229.167,146.167 227.833,146.833 226.5,147.5C 227.171,141.842 225.838,136.842 222.5,132.5C 222.573,130.973 221.906,129.973 220.5,129.5C 216.029,124.091 210.363,120.425 203.5,118.5C 201.485,117.076 199.152,116.41 196.5,116.5C 196.565,119.428 197.232,122.095 198.5,124.5C 200.795,137.15 207.795,145.816 219.5,150.5C 217.784,152.025 215.784,153.025 213.5,153.5C 210.611,152.295 207.944,150.628 205.5,148.5C 205.44,147.957 205.107,147.624 204.5,147.5C 203.511,151.107 203.177,154.774 203.5,158.5C 203.5,158.833 203.5,159.167 203.5,159.5C 201.716,159.893 200.05,160.559 198.5,161.5C 199.048,153.026 197.381,145.026 193.5,137.5C 192.277,136.386 190.944,136.219 189.5,137C 181.234,146.273 178.901,156.773 182.5,168.5C 182.027,169.906 181.027,170.573 179.5,170.5C 175.503,166.174 170.836,162.84 165.5,160.5C 165.082,159.778 164.416,159.278 163.5,159C 158.316,158.184 153.316,158.35 148.5,159.5C 147.5,159.5 146.5,159.5 145.5,159.5C 145.343,160.873 145.51,162.207 146,163.5C 149.391,168.055 153.225,172.055 157.5,175.5C 157.973,176.906 158.973,177.573 160.5,177.5C 160.842,178.338 161.508,178.672 162.5,178.5C 160.109,180.362 157.442,181.696 154.5,182.5C 153.331,178.656 150.998,175.656 147.5,173.5C 146.237,175.029 145.237,176.695 144.5,178.5C 144.167,178.5 143.833,178.5 143.5,178.5C 143.631,177.761 143.464,177.094 143,176.5C 142.667,177.5 142.333,178.5 142,179.5C 141.752,174.437 141.085,169.437 140,164.5C 139.517,165.448 139.351,166.448 139.5,167.5C 138.599,166.71 137.932,165.71 137.5,164.5C 137.573,162.973 136.906,161.973 135.5,161.5C 134.471,158.109 132.471,155.443 129.5,153.5C 128.053,152.115 127.053,152.448 126.5,154.5C 125.833,155.833 125.167,157.167 124.5,158.5C 123.027,161.017 122.36,163.85 122.5,167C 122.506,169.033 122.839,170.866 123.5,172.5C 125.066,178.114 128.066,182.947 132.5,187C 133.448,187.483 134.448,187.649 135.5,187.5C 134.791,188.404 133.791,188.737 132.5,188.5C 132.138,191.887 130.138,193.553 126.5,193.5C 127.287,191.896 128.62,191.229 130.5,191.5C 129.909,188.386 128.242,185.886 125.5,184C 118.841,179 111.508,177.5 103.5,179.5C 103.167,179.5 102.833,179.5 102.5,179.5C 102.611,178.883 102.944,178.383 103.5,178C 107.5,177.667 111.5,177.333 115.5,177C 111.179,176.501 106.846,176.334 102.5,176.5C 102.5,176.167 102.5,175.833 102.5,175.5C 106.399,175.369 109.732,174.036 112.5,171.5C 111.812,170.145 110.812,169.145 109.5,168.5C 109.5,166.5 108.5,165.5 106.5,165.5C 100.554,161.106 93.8876,159.439 86.5,160.5C 90.3123,159.676 94.3123,159.176 98.5,159C 94.6395,158.431 94.6395,157.598 98.5,156.5C 98.3764,155.893 98.0431,155.56 97.5,155.5C 97.5,155.167 97.5,154.833 97.5,154.5C 97.5,153.167 97.5,151.833 97.5,150.5C 98.1814,152.158 99.0147,153.825 100,155.5C 100.222,151.818 99.889,148.152 99,144.5C 98.1667,143.667 97.3333,142.833 96.5,142C 97.4158,141.722 98.0825,141.222 98.5,140.5C 100.864,137.477 103.031,134.144 105,130.5C 106.062,129.101 107.395,128.101 109,127.5C 112.596,129.265 115.763,131.598 118.5,134.5C 120.645,139.385 122.645,144.385 124.5,149.5C 125.249,147.988 126.416,146.988 128,146.5C 131.959,149.291 135.459,152.624 138.5,156.5C 140.647,157.835 142.647,157.669 144.5,156C 134.819,151.154 128.152,143.654 124.5,133.5C 125.01,131.912 126.01,130.745 127.5,130C 126.756,128.961 125.756,128.461 124.5,128.5C 119.864,124.696 115.697,120.362 112,115.5C 110.012,112.043 108.846,108.377 108.5,104.5C 111.807,103.949 115.14,103.616 118.5,103.5C 121.5,103.5 124.5,103.5 127.5,103.5C 127.737,102.209 127.404,101.209 126.5,100.5C 120.685,95.3653 117.019,89.032 115.5,81.5C 115.5,77.1667 115.5,72.8333 115.5,68.5C 117.074,66.8984 117.741,64.8984 117.5,62.5C 120.166,62.933 122.832,63.433 125.5,64C 128.986,65.996 132.319,68.1627 135.5,70.5C 138.637,73.2985 140.971,76.6319 142.5,80.5C 142.427,82.0269 143.094,83.0269 144.5,83.5C 145.648,85.7424 146.648,88.0758 147.5,90.5C 150.608,85.8885 154.275,81.7218 158.5,78C 159.833,77.3333 161.167,77.3333 162.5,78C 166.286,81.5859 168.953,85.7526 170.5,90.5C 170.336,93.1873 170.503,95.854 171,98.5C 171.278,99.4158 171.778,100.082 172.5,100.5C 171.963,105.436 173.463,106.436 177,103.5C 182.742,107.4 186.242,112.734 187.5,119.5C 187.5,123.833 187.5,128.167 187.5,132.5C 188.791,132.737 189.791,132.404 190.5,131.5C 191.167,130.833 191.833,130.167 192.5,129.5C 193.488,124.36 193.821,119.026 193.5,113.5C 195.604,113.799 197.604,113.466 199.5,112.5C 199.145,111.478 198.478,110.811 197.5,110.5C 197.167,109.5 196.5,108.833 195.5,108.5C 195.245,106.033 194.245,104.033 192.5,102.5C 192.598,100.447 191.931,98.7804 190.5,97.5C 189.646,91.8791 189.313,86.2124 189.5,80.5C 191.288,80.7852 192.955,80.4519 194.5,79.5C 190.054,72.8295 187.387,65.4962 186.5,57.5C 186.5,57.1667 186.5,56.8333 186.5,56.5C 187.166,53.9723 187.832,51.3056 188.5,48.5C 191.421,49.4066 194.421,49.7399 197.5,49.5C 200.475,49.7134 203.142,50.7134 205.5,52.5C 206.372,50.5342 206.205,48.5342 205,46.5C 201.885,32.8646 205.052,21.0312 214.5,11C 215.833,10.3333 217.167,10.3333 218.5,11C 224.266,15.2588 228.266,20.7588 230.5,27.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#635d5a",
    d: "M 197.5,110.5 C 198.478,110.811 199.145,111.478 199.5,112.5C 197.604,113.466 195.604,113.799 193.5,113.5C 193.821,119.026 193.488,124.36 192.5,129.5C 192.5,123.833 192.5,118.167 192.5,112.5C 194.781,112.923 196.448,112.256 197.5,110.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#cab427",
    d: "M 252.5,131.5 C 253.242,125.51 253.409,119.51 253,113.5C 251.275,114.464 249.441,115.131 247.5,115.5C 249.32,113.552 251.654,112.552 254.5,112.5C 254.844,119.082 254.177,125.416 252.5,131.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#b19f2d",
    d: "M 223.5,109.5 C 224.479,112.625 224.813,115.958 224.5,119.5C 222.901,119.768 221.568,119.434 220.5,118.5C 221.5,118.5 222.5,118.5 223.5,118.5C 223.5,115.5 223.5,112.5 223.5,109.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#8b7b2b",
    d: "M 203.5,118.5 C 201.856,118.714 200.356,118.38 199,117.5C 198.503,119.81 198.337,122.143 198.5,124.5C 197.232,122.095 196.565,119.428 196.5,116.5C 199.152,116.41 201.485,117.076 203.5,118.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#7f712c",
    d: "M 211.5,115.5 C 213.027,115.427 214.027,116.094 214.5,117.5C 212.973,117.573 211.973,116.906 211.5,115.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#70632c",
    d: "M 179.5,113.5 C 180.906,113.973 181.573,114.973 181.5,116.5C 180.094,116.027 179.427,115.027 179.5,113.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#efd20c",
    d: "M 179.5,113.5 C 179.427,115.027 180.094,116.027 181.5,116.5C 185.983,129.073 183.649,140.073 174.5,149.5C 173.386,150.776 172.386,150.776 171.5,149.5C 171.573,147.973 170.906,146.973 169.5,146.5C 168.492,143.156 167.492,139.823 166.5,136.5C 166.413,131.463 166.746,126.463 167.5,121.5C 169.037,116.94 171.704,113.107 175.5,110C 178.138,109.491 179.472,110.658 179.5,113.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#eed00d",
    d: "M 129.5,106.5 C 129.833,106.5 130.167,106.5 130.5,106.5C 131.93,107.537 133.597,108.204 135.5,108.5C 141.677,111.175 146.844,115.175 151,120.5C 153.498,124.672 152.331,127.172 147.5,128C 141.078,129.301 135.078,128.301 129.5,125C 123.93,120.932 119.263,116.098 115.5,110.5C 115.5,109.5 115.5,108.5 115.5,107.5C 120.119,106.686 124.786,106.353 129.5,106.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#a6a3a1",
    d: "M 192.5,102.5 C 194.245,104.033 195.245,106.033 195.5,108.5C 193.755,106.967 192.755,104.967 192.5,102.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#6a5d29",
    d: "M 130.5,106.5 C 132.698,106.12 134.365,106.787 135.5,108.5C 133.597,108.204 131.93,107.537 130.5,106.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#6c5e29",
    d: "M 129.5,106.5 C 124.786,106.353 120.119,106.686 115.5,107.5C 115.5,108.5 115.5,109.5 115.5,110.5C 114.566,109.432 114.232,108.099 114.5,106.5C 119.645,105.309 124.645,105.309 129.5,106.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#a09030",
    d: "M 142.5,101.5 C 142.5,102.5 142.5,103.5 142.5,104.5C 139.848,104.59 137.515,103.924 135.5,102.5C 137.262,102.357 138.929,102.691 140.5,103.5C 141.182,102.757 141.849,102.091 142.5,101.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#cab326",
    d: "M 218.5,98.5 C 221.393,100.748 223.06,103.748 223.5,107.5C 222.069,106.097 220.902,104.431 220,102.5C 219.667,102.833 219.333,103.167 219,103.5C 218.506,101.866 218.34,100.199 218.5,98.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#97872d",
    d: "M 132.5,100.5 C 134.027,100.427 135.027,101.094 135.5,102.5C 133.973,102.573 132.973,101.906 132.5,100.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#f3f2f2",
    d: "M 190.5,97.5 C 191.931,98.7804 192.598,100.447 192.5,102.5C 192.755,104.967 193.755,106.967 195.5,108.5C 196.5,108.833 197.167,109.5 197.5,110.5C 196.448,112.256 194.781,112.923 192.5,112.5C 192.5,118.167 192.5,123.833 192.5,129.5C 191.833,130.167 191.167,130.833 190.5,131.5C 188.869,127.768 187.869,123.768 187.5,119.5C 186.242,112.734 182.742,107.4 177,103.5C 173.463,106.436 171.963,105.436 172.5,100.5C 173.833,100.5 175.167,100.5 176.5,100.5C 181.422,100.13 186.089,99.1296 190.5,97.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#fab2b2",
    d: "M 190.5,97.5 C 186.089,99.1296 181.422,100.13 176.5,100.5C 180.766,98.2449 185.432,97.2449 190.5,97.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#632320",
    d: "M 170.5,90.5 C 172.011,93.5443 172.678,96.8776 172.5,100.5C 171.778,100.082 171.278,99.4158 171,98.5C 170.503,95.854 170.336,93.1873 170.5,90.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#423822",
    d: "M 197.5,85.5 C 196.252,86.3339 195.585,87.6672 195.5,89.5C 195.913,94.4958 197.247,99.1625 199.5,103.5C 197.247,99.1625 195.913,94.4958 195.5,89.5C 195.585,87.6672 196.252,86.3339 197.5,85.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#6d6029",
    d: "M 165.5,91.5 C 167.213,92.6354 167.88,94.302 167.5,96.5C 166.463,95.0697 165.796,93.403 165.5,91.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#f1d309",
    d: "M 197.5,85.5 C 202.6,86.255 207.266,88.0883 211.5,91C 214.739,92.7364 217.073,95.2364 218.5,98.5C 218.34,100.199 218.506,101.866 219,103.5C 219.333,103.167 219.667,102.833 220,102.5C 220.902,104.431 222.069,106.097 223.5,107.5C 223.5,108.167 223.5,108.833 223.5,109.5C 223.5,112.5 223.5,115.5 223.5,118.5C 222.5,118.5 221.5,118.5 220.5,118.5C 218.379,118.675 216.379,118.341 214.5,117.5C 214.027,116.094 213.027,115.427 211.5,115.5C 206.473,112.473 202.473,108.473 199.5,103.5C 197.247,99.1625 195.913,94.4958 195.5,89.5C 195.585,87.6672 196.252,86.3339 197.5,85.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#8d7d27",
    d: "M 248.5,81.5 C 249.568,80.5655 250.901,80.2322 252.5,80.5C 252.819,85.3633 252.486,90.03 251.5,94.5C 251.5,90.1667 251.5,85.8333 251.5,81.5C 250.5,81.5 249.5,81.5 248.5,81.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#f0d20b",
    d: "M 165.5,91.5 C 165.796,93.403 166.463,95.0697 167.5,96.5C 168.914,105.845 166.748,114.178 161,121.5C 159.887,123.329 158.387,124.163 156.5,124C 149.566,113.333 148.733,102.166 154,90.5C 155.679,87.4875 158.013,85.1541 161,83.5C 163.77,85.3652 165.27,88.0318 165.5,91.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#685b29",
    d: "M 211.5,85.5 C 213.403,85.7959 215.07,86.4625 216.5,87.5C 214.302,87.8799 212.635,87.2132 211.5,85.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#eed10d",
    d: "M 248.5,81.5 C 249.5,81.5 250.5,81.5 251.5,81.5C 251.5,85.8333 251.5,90.1667 251.5,94.5C 249.535,106.804 242.535,114.804 230.5,118.5C 229.353,118.182 228.519,117.516 228,116.5C 226.075,99.6811 232.908,88.0145 248.5,81.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#8f7f2d",
    d: "M 138.5,81.5 C 139.906,81.9731 140.573,82.9731 140.5,84.5C 139.094,84.0269 138.427,83.0269 138.5,81.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#742422",
    d: "M 142.5,80.5 C 143.906,80.9731 144.573,81.9731 144.5,83.5C 143.094,83.0269 142.427,82.0269 142.5,80.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#b29e27",
    d: "M 227.5,65.5 C 225.775,72.349 225.109,79.349 225.5,86.5C 226.5,86.5 227.5,86.5 228.5,86.5C 227.432,87.4345 226.099,87.7678 224.5,87.5C 224.334,81.4908 224.501,75.4908 225,69.5C 225.608,67.9336 226.442,66.6002 227.5,65.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#f1d309",
    d: "M 122.5,68.5 C 126.4,70.1227 130.067,72.2894 133.5,75C 135.765,76.7581 137.432,78.9248 138.5,81.5C 138.427,83.0269 139.094,84.0269 140.5,84.5C 142.21,90.0105 142.877,95.6772 142.5,101.5C 141.849,102.091 141.182,102.757 140.5,103.5C 138.929,102.691 137.262,102.357 135.5,102.5C 135.027,101.094 134.027,100.427 132.5,100.5C 126.26,96.3338 122.26,90.6671 120.5,83.5C 119.892,78.0557 120.558,73.0557 122.5,68.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#907f28",
    d: "M 122.5,68.5 C 120.558,73.0557 119.892,78.0557 120.5,83.5C 119.512,78.3595 119.179,73.0262 119.5,67.5C 120.791,67.2627 121.791,67.596 122.5,68.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#85762c",
    d: "M 216.5,68.5 C 217.906,68.9731 218.573,69.9731 218.5,71.5C 217.094,71.0269 216.427,70.0269 216.5,68.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#a6932c",
    d: "M 229.5,62.5 C 229.573,64.0269 228.906,65.0269 227.5,65.5C 227.427,63.9731 228.094,62.9731 229.5,62.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#6f622a",
    d: "M 191.5,58.5 C 192.738,60.2143 193.405,62.2143 193.5,64.5C 191.926,62.8984 191.259,60.8984 191.5,58.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#695d2c",
    d: "M 222.5,58.5 C 221.947,60.5518 220.947,60.8852 219.5,59.5C 220.609,59.4431 221.609,59.1098 222.5,58.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#eed10c",
    d: "M 216.5,68.5 C 216.427,70.0269 217.094,71.0269 218.5,71.5C 220.949,76.5133 221.949,81.8466 221.5,87.5C 219.833,87.5 218.167,87.5 216.5,87.5C 215.07,86.4625 213.403,85.7959 211.5,85.5C 201.997,81.4887 195.997,74.4887 193.5,64.5C 193.405,62.2143 192.738,60.2143 191.5,58.5C 191.5,56.8333 191.5,55.1667 191.5,53.5C 202.217,54.6856 210.551,59.6856 216.5,68.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#82732d",
    d: "M 226.5,50.5 C 226.245,52.9674 225.245,54.9674 223.5,56.5C 223.755,54.0326 224.755,52.0326 226.5,50.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#695c29",
    d: "M 246.5,49.5 C 247.209,48.596 248.209,48.2627 249.5,48.5C 249.818,53.0323 249.485,57.3656 248.5,61.5C 249.089,57.0293 248.423,53.0293 246.5,49.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#f2d408",
    d: "M 247.5,64.5 C 245.484,75.5184 239.151,82.8518 228.5,86.5C 227.5,86.5 226.5,86.5 225.5,86.5C 225.109,79.349 225.775,72.349 227.5,65.5C 228.906,65.0269 229.573,64.0269 229.5,62.5C 230.228,60.2654 231.561,58.4321 233.5,57C 236.139,54.5173 239.139,52.684 242.5,51.5C 244.117,50.962 245.784,50.6287 247.5,50.5C 247.5,55.1667 247.5,59.8333 247.5,64.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#c5b026",
    d: "M 246.5,49.5 C 248.423,53.0293 249.089,57.0293 248.5,61.5C 248.737,62.791 248.404,63.791 247.5,64.5C 247.5,59.8333 247.5,55.1667 247.5,50.5C 245.784,50.6287 244.117,50.962 242.5,51.5C 243.287,49.8958 244.62,49.2291 246.5,49.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#8a7a27",
    d: "M 226.5,30.5 C 227.222,30.9175 227.722,31.5842 228,32.5C 228.814,37.0204 228.647,41.3537 227.5,45.5C 227.587,40.4635 227.254,35.4635 226.5,30.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#a7942b",
    d: "M 212.5,23.5 C 212.31,26.855 211.31,29.855 209.5,32.5C 209.528,29.0836 210.528,26.0836 212.5,23.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#f0d30a",
    d: "M 226.5,30.5 C 227.254,35.4635 227.587,40.4635 227.5,45.5C 226.962,47.1172 226.629,48.7839 226.5,50.5C 224.755,52.0326 223.755,54.0326 223.5,56.5C 223.167,57.1667 222.833,57.8333 222.5,58.5C 221.609,59.1098 220.609,59.4431 219.5,59.5C 210.854,52.6485 207.521,43.6485 209.5,32.5C 211.31,29.855 212.31,26.855 212.5,23.5C 214.097,15.1144 217.263,14.4477 222,21.5C 224.038,24.2432 225.538,27.2432 226.5,30.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#979492",
    d: "M 187.5,119.5 C 187.869,123.768 188.869,127.768 190.5,131.5C 189.791,132.404 188.791,132.737 187.5,132.5C 187.5,128.167 187.5,123.833 187.5,119.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#b5a12b",
    d: "M 167.5,121.5 C 166.746,126.463 166.413,131.463 166.5,136.5C 165.838,134.696 165.505,132.696 165.5,130.5C 165.343,127.186 166.009,124.186 167.5,121.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#e4e1e1",
    d: "M 124.5,128.5 C 125.756,128.461 126.756,128.961 127.5,130C 126.01,130.745 125.01,131.912 124.5,133.5C 128.152,143.654 134.819,151.154 144.5,156C 142.647,157.669 140.647,157.835 138.5,156.5C 135.459,152.624 131.959,149.291 128,146.5C 126.416,146.988 125.249,147.988 124.5,149.5C 122.645,144.385 120.645,139.385 118.5,134.5C 120.167,132.167 122.167,130.167 124.5,128.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#65592a",
    d: "M 146.5,132.5 C 141.13,132.392 135.797,132.725 130.5,133.5C 133.356,131.994 136.523,131.328 140,131.5C 142.361,131.504 144.527,131.837 146.5,132.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#a4932d",
    d: "M 220.5,129.5 C 221.906,129.973 222.573,130.973 222.5,132.5C 221.094,132.027 220.427,131.027 220.5,129.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#98872a",
    d: "M 232.5,130.5 C 232.59,133.152 231.924,135.485 230.5,137.5C 230.41,134.848 231.076,132.515 232.5,130.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#f0d20c",
    d: "M 146.5,132.5 C 156.685,135.178 164.018,141.344 168.5,151C 168.355,151.772 168.022,152.439 167.5,153C 160.297,154.046 153.297,153.546 146.5,151.5C 146.027,150.094 145.027,149.427 143.5,149.5C 137.26,145.672 132.927,140.339 130.5,133.5C 135.797,132.725 141.13,132.392 146.5,132.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#eed10e",
    d: "M 118.5,146.5 C 119.392,151.438 119.726,156.438 119.5,161.5C 118.793,163.781 117.793,165.948 116.5,168C 115.167,168.667 113.833,168.667 112.5,168C 104.54,159.522 102.373,149.688 106,138.5C 106.68,136.487 108.013,135.154 110,134.5C 114.164,137.506 116.997,141.506 118.5,146.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#eed10c",
    d: "M 198.5,161.5 C 193.291,164.232 187.958,166.565 182.5,168.5C 178.901,156.773 181.234,146.273 189.5,137C 190.944,136.219 192.277,136.386 193.5,137.5C 197.381,145.026 199.048,153.026 198.5,161.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#f7a0a0",
    d: "M 302.5,142.5 C 299.14,142.616 295.807,142.949 292.5,143.5C 295.708,141.469 299.041,141.135 302.5,142.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#fef3f3",
    d: "M 302.5,142.5 C 306.591,143.695 308.924,146.361 309.5,150.5C 306.995,150.98 304.662,151.98 302.5,153.5C 300.205,150.61 297.205,149.777 293.5,151C 292.29,152.039 291.29,153.206 290.5,154.5C 289.839,156.134 289.506,157.967 289.5,160C 289.547,162.295 290.213,164.129 291.5,165.5C 294.294,172.159 298.46,173.159 304,168.5C 304.986,166.222 305.82,163.889 306.5,161.5C 308.49,160.502 310.49,159.502 312.5,158.5C 313.107,158.624 313.44,158.957 313.5,159.5C 313.54,162.881 313.207,166.214 312.5,169.5C 309.477,174.342 305.144,177.509 299.5,179C 293.342,180.672 288.509,178.838 285,173.5C 281.372,167.624 280.039,161.291 281,154.5C 283.406,149.259 287.239,145.592 292.5,143.5C 295.807,142.949 299.14,142.616 302.5,142.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#f37575",
    d: "M 63.5,139.5 C 63.2451,141.967 62.2451,143.967 60.5,145.5C 60.7549,143.033 61.7549,141.033 63.5,139.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#72642c",
    d: "M 169.5,146.5 C 170.906,146.973 171.573,147.973 171.5,149.5C 170.094,149.027 169.427,148.027 169.5,146.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#f3f0f0",
    d: "M 205.5,148.5 C 207.944,150.628 210.611,152.295 213.5,153.5C 211.209,154.765 208.875,156.098 206.5,157.5C 205.833,157.5 205.167,157.5 204.5,157.5C 204.19,154.287 204.523,151.287 205.5,148.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#8d7d2e",
    d: "M 143.5,149.5 C 145.027,149.427 146.027,150.094 146.5,151.5C 144.973,151.573 143.973,150.906 143.5,149.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#88792e",
    d: "M 129.5,153.5 C 128.391,153.557 127.391,153.89 126.5,154.5C 127.053,152.448 128.053,152.115 129.5,153.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#a39026",
    d: "M 118.5,146.5 C 119.117,146.611 119.617,146.944 120,147.5C 120.815,152.352 120.648,157.019 119.5,161.5C 119.726,156.438 119.392,151.438 118.5,146.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#898583",
    d: "M 205.5,148.5 C 204.523,151.287 204.19,154.287 204.5,157.5C 204.5,158.167 204.167,158.5 203.5,158.5C 203.177,154.774 203.511,151.107 204.5,147.5C 205.107,147.624 205.44,147.957 205.5,148.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#732322",
    d: "M 81.5,153.5 C 82.404,154.209 82.7373,155.209 82.5,156.5C 81.1667,156.5 79.8333,156.5 78.5,156.5C 79.9002,155.9 80.9002,154.9 81.5,153.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#eed10e",
    d: "M 129.5,153.5 C 132.471,155.443 134.471,158.109 135.5,161.5C 135.427,163.027 136.094,164.027 137.5,164.5C 137.932,165.71 138.599,166.71 139.5,167.5C 139.666,171.514 139.499,175.514 139,179.5C 137.604,182.064 136.437,184.731 135.5,187.5C 134.448,187.649 133.448,187.483 132.5,187C 128.066,182.947 125.066,178.114 123.5,172.5C 123.437,167.797 123.771,163.13 124.5,158.5C 125.167,157.167 125.833,155.833 126.5,154.5C 127.391,153.89 128.391,153.557 129.5,153.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#df7375",
    d: "M 204.5,157.5 C 205.167,157.5 205.833,157.5 206.5,157.5C 206.027,158.906 205.027,159.573 203.5,159.5C 203.5,159.167 203.5,158.833 203.5,158.5C 204.167,158.5 204.5,158.167 204.5,157.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#201917",
    d: "M 73.5,122.5 C 76.3718,123.325 79.3718,124.159 82.5,125C 89.6812,128.349 95.0146,133.516 98.5,140.5C 98.0825,141.222 97.4158,141.722 96.5,142C 97.3333,142.833 98.1667,143.667 99,144.5C 99.889,148.152 100.222,151.818 100,155.5C 99.0147,153.825 98.1814,152.158 97.5,150.5C 97.5905,147.848 96.9238,145.515 95.5,143.5C 95.0679,142.29 94.4013,141.29 93.5,140.5C 93.573,138.973 92.9063,137.973 91.5,137.5C 88.368,134.376 84.7013,132.043 80.5,130.5C 80.3893,129.883 80.056,129.383 79.5,129C 76.854,128.503 74.1873,128.336 71.5,128.5C 71.1706,131.228 71.8372,133.562 73.5,135.5C 75.5846,143.919 80.5846,149.919 88.5,153.5C 91.1709,155.118 94.1709,155.785 97.5,155.5C 98.0431,155.56 98.3764,155.893 98.5,156.5C 94.6395,157.598 94.6395,158.431 98.5,159C 94.3123,159.176 90.3123,159.676 86.5,160.5C 82.8351,160.58 79.5017,161.58 76.5,163.5C 75.1148,164.947 75.4482,165.947 77.5,166.5C 77.8333,167.5 78.5,168.167 79.5,168.5C 79.9731,169.906 80.9731,170.573 82.5,170.5C 82.9731,171.906 83.9731,172.573 85.5,172.5C 86.5137,173.674 87.847,174.34 89.5,174.5C 90.2625,175.268 91.2625,175.768 92.5,176C 95.8168,176.498 99.1501,176.665 102.5,176.5C 106.846,176.334 111.179,176.501 115.5,177C 111.5,177.333 107.5,177.667 103.5,178C 102.944,178.383 102.611,178.883 102.5,179.5C 99.6538,179.552 97.3204,180.552 95.5,182.5C 94.475,182.897 94.3083,183.563 95,184.5C 100.123,189.795 106.29,193.129 113.5,194.5C 116.976,195.643 120.642,195.81 124.5,195C 125.056,194.617 125.389,194.117 125.5,193.5C 125.833,193.5 126.167,193.5 126.5,193.5C 130.138,193.553 132.138,191.887 132.5,188.5C 133.791,188.737 134.791,188.404 135.5,187.5C 136.437,184.731 137.604,182.064 139,179.5C 139.499,175.514 139.666,171.514 139.5,167.5C 139.351,166.448 139.517,165.448 140,164.5C 141.085,169.437 141.752,174.437 142,179.5C 142.333,178.5 142.667,177.5 143,176.5C 143.464,177.094 143.631,177.761 143.5,178.5C 143.007,180.806 142.674,183.139 142.5,185.5C 142.5,186.5 142.5,187.5 142.5,188.5C 142.5,188.833 142.5,189.167 142.5,189.5C 136.818,191.674 131.484,194.341 126.5,197.5C 124.5,198.167 122.5,198.833 120.5,199.5C 114.572,199.879 108.905,198.879 103.5,196.5C 103.027,195.094 102.027,194.427 100.5,194.5C 97.8333,192.833 95.1667,191.167 92.5,189.5C 91.0877,186.904 89.4211,184.404 87.5,182C 87.7591,180.739 88.4258,179.739 89.5,179C 81.1958,176.099 74.6958,170.932 70,163.5C 71.0161,159.341 73.8494,157.008 78.5,156.5C 79.8333,156.5 81.1667,156.5 82.5,156.5C 82.7373,155.209 82.404,154.209 81.5,153.5C 74.598,147.698 70.2647,140.364 68.5,131.5C 68.5,128.5 68.5,125.5 68.5,122.5C 70.1667,122.5 71.8333,122.5 73.5,122.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#73652a",
    d: "M 88.5,153.5 C 91.4824,153.963 94.4824,154.296 97.5,154.5C 97.5,154.833 97.5,155.167 97.5,155.5C 94.1709,155.785 91.1709,155.118 88.5,153.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#a08e2a",
    d: "M 95.5,143.5 C 96.9238,145.515 97.5905,147.848 97.5,150.5C 96.0762,148.485 95.4095,146.152 95.5,143.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#a6942e",
    d: "M 91.5,137.5 C 92.9063,137.973 93.573,138.973 93.5,140.5C 92.0937,140.027 91.427,139.027 91.5,137.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#f1d30a",
    d: "M 80.5,130.5 C 84.7013,132.043 88.368,134.376 91.5,137.5C 91.427,139.027 92.0937,140.027 93.5,140.5C 94.4013,141.29 95.0679,142.29 95.5,143.5C 95.4095,146.152 96.0762,148.485 97.5,150.5C 97.5,151.833 97.5,153.167 97.5,154.5C 94.4824,154.296 91.4824,153.963 88.5,153.5C 80.5846,149.919 75.5846,143.919 73.5,135.5C 73.1667,133.5 72.8333,131.5 72.5,129.5C 75.2372,129.401 77.9039,129.735 80.5,130.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#97862b",
    d: "M 80.5,130.5 C 77.9039,129.735 75.2372,129.401 72.5,129.5C 72.8333,131.5 73.1667,133.5 73.5,135.5C 71.8372,133.562 71.1706,131.228 71.5,128.5C 74.1873,128.336 76.854,128.503 79.5,129C 80.056,129.383 80.3893,129.883 80.5,130.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#635729",
    d: "M 148.5,159.5 C 153.316,158.35 158.316,158.184 163.5,159C 164.416,159.278 165.082,159.778 165.5,160.5C 159.87,159.708 154.203,159.375 148.5,159.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#f69697",
    d: "M 263.5,162.5 C 258.73,161.133 254.063,161.466 249.5,163.5C 251.759,161.245 254.592,160.245 258,160.5C 259.5,160.667 261,160.833 262.5,161C 263.056,161.383 263.389,161.883 263.5,162.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#efd20c",
    d: "M 86.5,160.5 C 93.8876,159.439 100.554,161.106 106.5,165.5C 107.167,166.833 108.167,167.833 109.5,168.5C 110.812,169.145 111.812,170.145 112.5,171.5C 109.732,174.036 106.399,175.369 102.5,175.5C 98.1311,175.533 93.7978,175.2 89.5,174.5C 87.847,174.34 86.5137,173.674 85.5,172.5C 85.0269,171.094 84.0269,170.427 82.5,170.5C 82.0269,169.094 81.0269,168.427 79.5,168.5C 78.5,168.167 77.8333,167.5 77.5,166.5C 76.8902,165.609 76.5569,164.609 76.5,163.5C 79.5017,161.58 82.8351,160.58 86.5,160.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#f0d20a",
    d: "M 148.5,159.5 C 154.203,159.375 159.87,159.708 165.5,160.5C 170.836,162.84 175.503,166.174 179.5,170.5C 174.254,173.955 168.587,176.622 162.5,178.5C 161.508,178.672 160.842,178.338 160.5,177.5C 160.027,176.094 159.027,175.427 157.5,175.5C 153.225,172.055 149.391,168.055 146,163.5C 145.51,162.207 145.343,160.873 145.5,159.5C 146.5,159.5 147.5,159.5 148.5,159.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#fef4f4",
    d: "M 263.5,162.5 C 266.869,163.559 268.536,165.892 268.5,169.5C 266.046,169.321 263.879,169.987 262,171.5C 256.994,167.098 252.66,167.765 249,173.5C 247.338,180.169 249.172,185.669 254.5,190C 258.55,190.642 261.55,189.142 263.5,185.5C 264.309,183.972 264.976,182.306 265.5,180.5C 267.604,179.088 269.937,178.088 272.5,177.5C 273.647,188.203 268.98,195.036 258.5,198C 248.28,198.628 242.28,193.795 240.5,183.5C 240.522,178.728 241.189,174.061 242.5,169.5C 243.92,166.412 246.253,164.412 249.5,163.5C 254.063,161.466 258.73,161.133 263.5,162.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#f58b8d",
    d: "M 313.5,159.5 C 314.156,160.622 314.489,161.955 314.5,163.5C 314.639,165.883 313.972,167.883 312.5,169.5C 313.207,166.214 313.54,162.881 313.5,159.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#fee2e1",
    d: "M 319.5,160.5 C 320.5,160.5 321.5,160.5 322.5,160.5C 322.993,162.806 323.326,165.139 323.5,167.5C 321.194,167.993 318.861,168.326 316.5,168.5C 315.829,165.014 316.829,162.347 319.5,160.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#fab9ba",
    d: "M 54.5,161.5 C 53.6766,164.461 53.01,167.461 52.5,170.5C 52.1667,170.5 51.8333,170.5 51.5,170.5C 51.446,167.008 52.446,164.008 54.5,161.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#9a892c",
    d: "M 135.5,161.5 C 136.906,161.973 137.573,162.973 137.5,164.5C 136.094,164.027 135.427,163.027 135.5,161.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#8e7e30",
    d: "M 76.5,163.5 C 76.5569,164.609 76.8902,165.609 77.5,166.5C 75.4482,165.947 75.1148,164.947 76.5,163.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#75682a",
    d: "M 124.5,158.5 C 123.771,163.13 123.437,167.797 123.5,172.5C 122.839,170.866 122.506,169.033 122.5,167C 122.36,163.85 123.027,161.017 124.5,158.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#f9aeae",
    d: "M 290.5,154.5 C 290.323,158.234 290.656,161.901 291.5,165.5C 290.213,164.129 289.547,162.295 289.5,160C 289.506,157.967 289.839,156.134 290.5,154.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#675a2c",
    d: "M 106.5,165.5 C 108.5,165.5 109.5,166.5 109.5,168.5C 108.167,167.833 107.167,166.833 106.5,165.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#a7962e",
    d: "M 79.5,168.5 C 81.0269,168.427 82.0269,169.094 82.5,170.5C 80.9731,170.573 79.9731,169.906 79.5,168.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#ab9831",
    d: "M 82.5,170.5 C 84.0269,170.427 85.0269,171.094 85.5,172.5C 83.9731,172.573 82.9731,171.906 82.5,170.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.241
    },
    fill: "#656a72",
    d: "M 358.5,170.5 C 359.117,170.611 359.617,170.944 360,171.5C 360.497,173.81 360.663,176.143 360.5,178.5C 359.629,175.997 358.963,173.33 358.5,170.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.341
    },
    fill: "#7b7f86",
    d: "M 43.5,170.5 C 43.0372,173.33 42.3705,175.997 41.5,178.5C 40.9644,175.302 41.631,172.635 43.5,170.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#8f7f2b",
    d: "M 89.5,174.5 C 93.7978,175.2 98.1311,175.533 102.5,175.5C 102.5,175.833 102.5,176.167 102.5,176.5C 99.1501,176.665 95.8168,176.498 92.5,176C 91.2625,175.768 90.2625,175.268 89.5,174.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#f26d6f",
    d: "M 51.5,170.5 C 51.8333,170.5 52.1667,170.5 52.5,170.5C 52.5905,173.152 51.9238,175.485 50.5,177.5C 50.6741,175.139 51.0074,172.806 51.5,170.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#9c8a2d",
    d: "M 157.5,175.5 C 159.027,175.427 160.027,176.094 160.5,177.5C 158.973,177.573 157.973,176.906 157.5,175.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#eed210",
    d: "M 154.5,182.5 C 151.098,185.535 147.098,187.535 142.5,188.5C 142.5,187.5 142.5,186.5 142.5,185.5C 143.924,183.485 144.59,181.152 144.5,178.5C 145.237,176.695 146.237,175.029 147.5,173.5C 150.998,175.656 153.331,178.656 154.5,182.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#fbc7c7",
    d: "M 242.5,169.5 C 241.189,174.061 240.522,178.728 240.5,183.5C 239.357,180.024 239.19,176.358 240,172.5C 240.377,171.058 241.21,170.058 242.5,169.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#f47c7d",
    d: "M 350.5,172.5 C 351.525,175.974 352.192,179.64 352.5,183.5C 350.783,180.155 350.116,176.489 350.5,172.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#fef3f3",
    d: "M 226.5,210.5 C 226.006,207.094 224.339,206.094 221.5,207.5C 219.307,208.68 216.974,209.68 214.5,210.5C 213.833,213.167 213.167,215.833 212.5,218.5C 210.22,219.136 208.22,220.136 206.5,221.5C 204.631,219.365 203.964,216.698 204.5,213.5C 204.5,212.167 204.5,210.833 204.5,209.5C 206.031,204.75 206.698,199.75 206.5,194.5C 206.335,190.818 206.501,187.152 207,183.5C 209.797,181.116 212.964,179.949 216.5,180C 222,187.5 227.5,195 233,202.5C 234.559,204.217 235.392,206.217 235.5,208.5C 232.574,209.461 229.574,210.127 226.5,210.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#a6942c",
    d: "M 102.5,179.5 C 102.833,179.5 103.167,179.5 103.5,179.5C 101.064,180.871 98.3973,181.871 95.5,182.5C 97.3204,180.552 99.6538,179.552 102.5,179.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#edd010",
    d: "M 126.5,193.5 C 126.167,193.5 125.833,193.5 125.5,193.5C 121.566,194.36 117.566,194.693 113.5,194.5C 106.29,193.129 100.123,189.795 95,184.5C 94.3083,183.563 94.475,182.897 95.5,182.5C 98.3973,181.871 101.064,180.871 103.5,179.5C 111.508,177.5 118.841,179 125.5,184C 128.242,185.886 129.909,188.386 130.5,191.5C 128.62,191.229 127.287,191.896 126.5,193.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#a49229",
    d: "M 143.5,178.5 C 143.833,178.5 144.167,178.5 144.5,178.5C 144.59,181.152 143.924,183.485 142.5,185.5C 142.674,183.139 143.007,180.806 143.5,178.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#fee2e3",
    d: "M 278.5,180.5 C 282.009,180.808 283.676,182.808 283.5,186.5C 281.167,187.167 278.833,187.833 276.5,188.5C 276.481,186.94 276.148,185.44 275.5,184C 276.071,182.401 277.071,181.234 278.5,180.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#f6999b",
    d: "M 265.5,180.5 C 264.976,182.306 264.309,183.972 263.5,185.5C 263.077,183.219 263.744,181.552 265.5,180.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#f8acad",
    d: "M 50.5,178.5 C 50.1916,182.36 49.5249,186.026 48.5,189.5C 48.3354,186.482 48.502,183.482 49,180.5C 49.2784,179.584 49.7784,178.918 50.5,178.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.678
    },
    fill: "#a9acb1",
    d: "M 360.5,178.5 C 361.662,194.661 361.828,210.995 361,227.5C 360.617,228.056 360.117,228.389 359.5,228.5C 360.471,211.881 360.805,195.214 360.5,178.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.803
    },
    fill: "#bec0c3",
    d: "M 41.5,178.5 C 41.2643,196.852 41.5976,215.185 42.5,233.5C 41.6909,231.708 41.1909,229.708 41,227.5C 40.1718,210.995 40.3385,194.661 41.5,178.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#f8f5f5",
    d: "M 92.5,189.5 C 95.1667,191.167 97.8333,192.833 100.5,194.5C 100.973,195.906 101.973,196.573 103.5,196.5C 108.905,198.879 114.572,199.879 120.5,199.5C 117.871,201.163 115.204,202.829 112.5,204.5C 106.818,206.674 101.484,209.341 96.5,212.5C 95.391,212.557 94.391,212.89 93.5,213.5C 91.5388,206.913 90.8721,199.913 91.5,192.5C 91.2627,191.209 91.596,190.209 92.5,189.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#fef4f4",
    d: "M 190.5,196.5 C 190.5,197.5 190.5,198.5 190.5,199.5C 188.62,199.229 187.287,199.896 186.5,201.5C 184.405,201.76 183.072,202.926 182.5,205C 184.374,212.703 186.374,220.369 188.5,228C 188.355,228.772 188.022,229.439 187.5,230C 184.904,231.136 182.237,231.969 179.5,232.5C 178.751,226.347 177.418,220.347 175.5,214.5C 175.59,211.848 174.924,209.515 173.5,207.5C 170.759,207.707 168.426,208.707 166.5,210.5C 165.1,209.9 164.1,208.9 163.5,207.5C 162.272,205.99 162.272,204.49 163.5,203C 167.858,201.152 172.192,199.319 176.5,197.5C 178.967,197.245 180.967,196.245 182.5,194.5C 184.993,193.226 187.659,192.56 190.5,192.5C 190.5,193.833 190.5,195.167 190.5,196.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#c52e30",
    d: "M 142.5,189.5 C 139.153,191.416 136.653,193.75 135,196.5C 134.439,195.978 133.772,195.645 133,195.5C 130.846,196.274 128.679,196.941 126.5,197.5C 131.484,194.341 136.818,191.674 142.5,189.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#4b4024",
    d: "M 125.5,193.5 C 125.389,194.117 125.056,194.617 124.5,195C 120.642,195.81 116.976,195.643 113.5,194.5C 117.566,194.693 121.566,194.36 125.5,193.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#fcfafa",
    d: "M 315.5,215.5 C 315.296,218.518 314.963,221.518 314.5,224.5C 308.437,255.892 291.77,279.892 264.5,296.5C 263.833,287.833 263.167,279.167 262.5,270.5C 262.173,261.318 262.507,252.318 263.5,243.5C 270.362,252.022 277.362,260.522 284.5,269C 285.793,269.49 287.127,269.657 288.5,269.5C 288.66,267.801 288.494,266.134 288,264.5C 285.396,258.846 282.896,253.179 280.5,247.5C 280.245,245.033 279.245,243.033 277.5,241.5C 277.5,241.167 277.5,240.833 277.5,240.5C 277.245,238.033 276.245,236.033 274.5,234.5C 273.099,230.584 271.432,226.75 269.5,223C 264.34,223.407 259.673,225.241 255.5,228.5C 254.833,228.5 254.5,228.833 254.5,229.5C 253.833,248.833 253.167,268.167 252.5,287.5C 251.985,285.106 251.319,282.772 250.5,280.5C 250.048,276.837 249.548,273.17 249,269.5C 248.722,268.584 248.222,267.918 247.5,267.5C 247.5,267.167 247.5,266.833 247.5,266.5C 246.674,257.519 245.007,248.852 242.5,240.5C 242.5,239.833 242.5,239.167 242.5,238.5C 242.829,235.772 242.163,233.438 240.5,231.5C 240.5,230.833 240.5,230.167 240.5,229.5C 251.828,223.271 263.495,217.605 275.5,212.5C 277.967,212.245 279.967,211.245 281.5,209.5C 290.201,204.597 299.201,200.263 308.5,196.5C 310.936,196.683 313.103,196.016 315,194.5C 315.5,201.492 315.666,208.492 315.5,215.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#736e6c",
    d: "M 100.5,194.5 C 102.027,194.427 103.027,195.094 103.5,196.5C 101.973,196.573 100.973,195.906 100.5,194.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#f8a4a5",
    d: "M 182.5,194.5 C 180.967,196.245 178.967,197.245 176.5,197.5C 178.033,195.755 180.033,194.755 182.5,194.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#f47b7a",
    d: "M 190.5,196.5 C 191.434,197.568 191.768,198.901 191.5,200.5C 189.784,200.629 188.117,200.962 186.5,201.5C 187.287,199.896 188.62,199.229 190.5,199.5C 190.5,198.5 190.5,197.5 190.5,196.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#ee4543",
    d: "M 213.5,191.5 C 215.364,192.82 217.031,194.487 218.5,196.5C 220.076,200.339 218.743,202.672 214.5,203.5C 213.509,199.555 213.176,195.555 213.5,191.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#fee3e3",
    d: "M 238.5,198.5 C 241.524,198.175 243.191,199.508 243.5,202.5C 242.461,204.531 240.795,205.864 238.5,206.5C 235.843,203.867 235.843,201.201 238.5,198.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#fac1c2",
    d: "M 316.5,215.5 C 316.167,215.5 315.833,215.5 315.5,215.5C 315.666,208.492 315.5,201.492 315,194.5C 313.103,196.016 310.936,196.683 308.5,196.5C 310.792,194.733 313.458,193.733 316.5,193.5C 316.5,200.833 316.5,208.167 316.5,215.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#f7a6a7",
    d: "M 91.5,192.5 C 90.8721,199.913 91.5388,206.913 93.5,213.5C 92.791,214.404 91.791,214.737 90.5,214.5C 90.175,206.981 90.5084,199.648 91.5,192.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#f48182",
    d: "M 206.5,194.5 C 206.698,199.75 206.031,204.75 204.5,209.5C 204.189,204.234 204.855,199.234 206.5,194.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#f15754",
    d: "M 112.5,204.5 C 111.918,205.931 111.085,207.264 110,208.5C 108.187,207.391 107.354,208.058 107.5,210.5C 103.681,210.414 100.015,211.081 96.5,212.5C 101.484,209.341 106.818,206.674 112.5,204.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#f37070",
    d: "M 221.5,207.5 C 224.339,206.094 226.006,207.094 226.5,210.5C 225.33,208.721 223.664,207.721 221.5,207.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#f79b9c",
    d: "M 163.5,207.5 C 164.1,208.9 165.1,209.9 166.5,210.5C 165.791,211.404 164.791,211.737 163.5,211.5C 163.5,210.167 163.5,208.833 163.5,207.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#f48384",
    d: "M 173.5,207.5 C 174.924,209.515 175.59,211.848 175.5,214.5C 174.076,212.485 173.41,210.152 173.5,207.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#f8a5a6",
    d: "M 281.5,209.5 C 279.967,211.245 277.967,212.245 275.5,212.5C 277.033,210.755 279.033,209.755 281.5,209.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#fef9f9",
    d: "M 196.5,218.5 C 197.833,218.5 199.167,218.5 200.5,218.5C 200.675,220.621 200.341,222.621 199.5,224.5C 198.833,224.5 198.167,224.5 197.5,224.5C 195.155,223.012 194.821,221.012 196.5,218.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#f37c7e",
    d: "M 204.5,213.5 C 203.964,216.698 204.631,219.365 206.5,221.5C 205.791,222.404 204.791,222.737 203.5,222.5C 203.19,219.287 203.523,216.287 204.5,213.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#f69596",
    d: "M 196.5,218.5 C 197.919,217.549 199.585,217.216 201.5,217.5C 202.01,220.388 201.344,222.721 199.5,224.5C 200.341,222.621 200.675,220.621 200.5,218.5C 199.167,218.5 197.833,218.5 196.5,218.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#f37676",
    d: "M 315.5,215.5 C 315.833,215.5 316.167,215.5 316.5,215.5C 316.664,218.187 316.497,220.854 316,223.5C 315.617,224.056 315.117,224.389 314.5,224.5C 314.963,221.518 315.296,218.518 315.5,215.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#fef0f0",
    d: "M 136.5,239.5 C 136.41,242.152 137.076,244.485 138.5,246.5C 139.15,248.435 139.483,250.435 139.5,252.5C 136.833,253.167 134.167,253.833 131.5,254.5C 129.715,246.913 128.048,239.246 126.5,231.5C 128.615,228.442 131.615,226.942 135.5,227C 140.106,221.744 145.106,221.244 150.5,225.5C 152.473,232.057 153.807,238.724 154.5,245.5C 152.323,245.586 150.323,246.253 148.5,247.5C 146.31,242.008 144.31,236.508 142.5,231C 140.765,230.349 139.098,230.515 137.5,231.5C 136.52,234.086 136.187,236.753 136.5,239.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#f9bbbc",
    d: "M 196.5,218.5 C 194.821,221.012 195.155,223.012 197.5,224.5C 196.791,225.404 195.791,225.737 194.5,225.5C 193.99,222.612 194.656,220.279 196.5,218.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#fee1e1",
    d: "M 116.5,223.5 C 117.5,223.5 118.5,223.5 119.5,223.5C 119.808,225.924 119.474,228.257 118.5,230.5C 112.785,235.223 110.619,233.89 112,226.5C 113.652,225.601 115.152,224.601 116.5,223.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#373435",
    d: "M 274.5,234.5 C 274.755,236.967 275.755,238.967 277.5,240.5C 277.5,240.833 277.5,241.167 277.5,241.5C 277.755,243.967 278.755,245.967 280.5,247.5C 282.896,253.179 285.396,258.846 288,264.5C 288.494,266.134 288.66,267.801 288.5,269.5C 287.127,269.657 285.793,269.49 284.5,269C 277.362,260.522 270.362,252.022 263.5,243.5C 263.44,242.957 263.107,242.624 262.5,242.5C 261.172,261.329 261.172,279.996 262.5,298.5C 262.666,306.507 262.5,314.507 262,322.5C 257.454,326.749 252.287,327.582 246.5,325C 241.86,319.514 236.527,315.014 230.5,311.5C 223.187,304.521 215.854,297.521 208.5,290.5C 207.675,289.614 206.675,289.281 205.5,289.5C 203.579,298.139 200.913,306.472 197.5,314.5C 196.326,315.514 195.66,316.847 195.5,318.5C 194.217,320.606 193.384,322.94 193,325.5C 191.951,326.517 190.784,326.684 189.5,326C 188.536,321.934 188.203,317.767 188.5,313.5C 189.167,313.5 189.5,313.167 189.5,312.5C 189.82,301.923 190.486,291.423 191.5,281C 196.864,280.171 202.198,280.337 207.5,281.5C 216.352,289.52 225.352,297.353 234.5,305C 235.332,305.688 235.998,305.521 236.5,304.5C 223.307,285.637 207.974,268.637 190.5,253.5C 192.794,251.612 195.461,250.278 198.5,249.5C 210.492,263.491 222.825,277.158 235.5,290.5C 236.723,293.274 238.223,295.941 240,298.5C 240.893,299.711 241.726,299.711 242.5,298.5C 239.711,292.582 236.711,286.915 233.5,281.5C 227.348,268.433 221.014,255.433 214.5,242.5C 216.336,240.412 218.669,239.079 221.5,238.5C 225.492,247.466 229.492,256.466 233.5,265.5C 233.427,267.027 234.094,268.027 235.5,268.5C 237.716,272.266 239.383,276.266 240.5,280.5C 240.755,282.967 241.755,284.967 243.5,286.5C 243.926,289.21 245.093,291.544 247,293.5C 247.099,289.239 246.266,285.239 244.5,281.5C 243.622,275.659 242.289,269.992 240.5,264.5C 240.247,260.96 239.581,257.627 238.5,254.5C 237.302,247.176 235.969,239.843 234.5,232.5C 236.181,230.992 238.181,229.992 240.5,229.5C 240.5,230.167 240.5,230.833 240.5,231.5C 240.41,234.152 241.076,236.485 242.5,238.5C 242.5,239.167 242.5,239.833 242.5,240.5C 242.336,243.187 242.503,245.854 243,248.5C 243.999,254.747 245.499,260.747 247.5,266.5C 247.5,266.833 247.5,267.167 247.5,267.5C 247.763,272.124 248.763,276.458 250.5,280.5C 251.319,282.772 251.985,285.106 252.5,287.5C 252.5,288.167 252.5,288.833 252.5,289.5C 252.343,290.873 252.51,292.207 253,293.5C 253.667,294.833 254.333,294.833 255,293.5C 255.5,271.836 255.667,250.169 255.5,228.5C 259.673,225.241 264.34,223.407 269.5,223C 271.432,226.75 273.099,230.584 274.5,234.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#646263",
    d: "M 255.5,228.5 C 255.667,250.169 255.5,271.836 255,293.5C 254.333,294.833 253.667,294.833 253,293.5C 252.51,292.207 252.343,290.873 252.5,289.5C 253.268,290.263 253.768,291.263 254,292.5C 254.5,271.503 254.667,250.503 254.5,229.5C 254.5,228.833 254.833,228.5 255.5,228.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#d0d0d0",
    d: "M 254.5,229.5 C 254.667,250.503 254.5,271.503 254,292.5C 253.768,291.263 253.268,290.263 252.5,289.5C 252.5,288.833 252.5,288.167 252.5,287.5C 253.167,268.167 253.833,248.833 254.5,229.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#fef3f3",
    d: "M 92.5,247.5 C 98.0415,247.782 103.708,248.115 109.5,248.5C 114.65,251.651 115.817,255.984 113,261.5C 106.233,269.655 98.0659,271.821 88.5,268C 85.5539,263.559 86.8872,261.059 92.5,260.5C 96.8393,263.273 101.006,262.939 105,259.5C 105.579,258.072 105.412,256.738 104.5,255.5C 99.3359,254.648 94.0025,254.648 88.5,255.5C 82.9356,252.936 81.1023,248.603 83,242.5C 88.6155,234.406 96.1155,231.906 105.5,235C 107.616,236.171 108.282,237.671 107.5,239.5C 104.596,242.393 101.263,243.06 97.5,241.5C 95.8034,241.899 94.1368,242.399 92.5,243C 91.1991,244.616 91.1991,246.116 92.5,247.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#fef3f3",
    d: "M 123.5,242.5 C 124.475,245.311 125.142,248.311 125.5,251.5C 125.517,253.565 125.85,255.565 126.5,257.5C 124.517,258.152 122.683,259.152 121,260.5C 120.228,260.355 119.561,260.022 119,259.5C 117.907,251.938 116.074,244.604 113.5,237.5C 114.283,235.712 115.616,234.712 117.5,234.5C 118.496,234.586 119.329,234.252 120,233.5C 120.505,236.865 121.672,239.865 123.5,242.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#f2f0f0",
    d: "M 234.5,232.5 C 235.969,239.843 237.302,247.176 238.5,254.5C 238.336,257.187 238.503,259.854 239,262.5C 239.278,263.416 239.778,264.082 240.5,264.5C 242.289,269.992 243.622,275.659 244.5,281.5C 244.768,283.099 244.434,284.432 243.5,285.5C 243.047,283.435 242.047,281.768 240.5,280.5C 239.383,276.266 237.716,272.266 235.5,268.5C 235.573,266.973 234.906,265.973 233.5,265.5C 229.492,256.466 225.492,247.466 221.5,238.5C 225.385,235.727 229.718,233.727 234.5,232.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#f69192",
    d: "M 352.5,222.5 C 352.23,227.45 351.23,232.117 349.5,236.5C 349.77,231.55 350.77,226.883 352.5,222.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#f69c9e",
    d: "M 50.5,230.5 C 51.9238,232.515 52.5905,234.848 52.5,237.5C 51.0762,235.485 50.4095,233.152 50.5,230.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#fbbcbc",
    d: "M 123.5,242.5 C 121.672,239.865 120.505,236.865 120,233.5C 119.329,234.252 118.496,234.586 117.5,234.5C 118.287,232.896 119.62,232.229 121.5,232.5C 122.167,235.833 122.833,239.167 123.5,242.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#8f8e8e",
    d: "M 240.5,231.5 C 242.163,233.438 242.829,235.772 242.5,238.5C 241.076,236.485 240.41,234.152 240.5,231.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#898789",
    d: "M 274.5,234.5 C 276.245,236.033 277.245,238.033 277.5,240.5C 275.755,238.967 274.755,236.967 274.5,234.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#f8abac",
    d: "M 136.5,239.5 C 137.924,241.515 138.59,243.848 138.5,246.5C 137.076,244.485 136.41,242.152 136.5,239.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#f4f2f2",
    d: "M 214.5,242.5 C 221.014,255.433 227.348,268.433 233.5,281.5C 234.578,284.402 235.244,287.402 235.5,290.5C 222.825,277.158 210.492,263.491 198.5,249.5C 203.307,246.1 208.64,243.766 214.5,242.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#f58989",
    d: "M 348.5,242.5 C 348.204,244.403 347.537,246.07 346.5,247.5C 346.12,245.302 346.787,243.635 348.5,242.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#898889",
    d: "M 277.5,241.5 C 279.245,243.033 280.245,245.033 280.5,247.5C 278.755,245.967 277.755,243.967 277.5,241.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#fbcacb",
    d: "M 109.5,248.5 C 103.708,248.115 98.0415,247.782 92.5,247.5C 97.8202,246.734 103.154,246.568 108.5,247C 109.056,247.383 109.389,247.883 109.5,248.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#757475",
    d: "M 242.5,240.5 C 245.007,248.852 246.674,257.519 247.5,266.5C 245.499,260.747 243.999,254.747 243,248.5C 242.503,245.854 242.336,243.187 242.5,240.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#f16564",
    d: "M 104.5,255.5 C 99.0087,256.559 93.6754,256.559 88.5,255.5C 94.0025,254.648 99.3359,254.648 104.5,255.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#f69192",
    d: "M 125.5,251.5 C 127.461,253.32 127.794,255.32 126.5,257.5C 125.85,255.565 125.517,253.565 125.5,251.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#fbf8f8",
    d: "M 190.5,253.5 C 207.974,268.637 223.307,285.637 236.5,304.5C 235.998,305.521 235.332,305.688 234.5,305C 225.352,297.353 216.352,289.52 207.5,281.5C 202.198,280.337 196.864,280.171 191.5,281C 190.486,291.423 189.82,301.923 189.5,312.5C 185.548,311.728 181.548,311.395 177.5,311.5C 165.197,308.938 153.863,304.272 143.5,297.5C 143.027,296.094 142.027,295.427 140.5,295.5C 135.254,292.589 130.587,288.922 126.5,284.5C 133.978,279.556 141.978,275.556 150.5,272.5C 152.967,272.245 154.967,271.245 156.5,269.5C 167.523,263.657 178.856,258.324 190.5,253.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#f69697",
    d: "M 344.5,254.5 C 344.573,256.027 343.906,257.027 342.5,257.5C 342.427,255.973 343.094,254.973 344.5,254.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#a8a8a8",
    d: "M 238.5,254.5 C 239.581,257.627 240.247,260.96 240.5,264.5C 239.778,264.082 239.278,263.416 239,262.5C 238.503,259.854 238.336,257.187 238.5,254.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#8d8c8c",
    d: "M 233.5,265.5 C 234.906,265.973 235.573,266.973 235.5,268.5C 234.094,268.027 233.427,267.027 233.5,265.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#f79495",
    d: "M 338.5,267.5 C 338.573,269.027 337.906,270.027 336.5,270.5C 336.427,268.973 337.094,267.973 338.5,267.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#f9aeae",
    d: "M 156.5,269.5 C 154.967,271.245 152.967,272.245 150.5,272.5C 152.033,270.755 154.033,269.755 156.5,269.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#767474",
    d: "M 263.5,243.5 C 262.507,252.318 262.173,261.318 262.5,270.5C 262.173,279.682 262.507,288.682 263.5,297.5C 263.5,298.167 263.167,298.5 262.5,298.5C 261.172,279.996 261.172,261.329 262.5,242.5C 263.107,242.624 263.44,242.957 263.5,243.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#d1cfcf",
    d: "M 262.5,270.5 C 263.167,279.167 263.833,287.833 264.5,296.5C 264.5,297.167 264.167,297.5 263.5,297.5C 262.507,288.682 262.173,279.682 262.5,270.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#7c7b7c",
    d: "M 247.5,267.5 C 248.222,267.918 248.722,268.584 249,269.5C 249.548,273.17 250.048,276.837 250.5,280.5C 248.763,276.458 247.763,272.124 247.5,267.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#747373",
    d: "M 240.5,280.5 C 242.047,281.768 243.047,283.435 243.5,285.5C 243.5,285.833 243.5,286.167 243.5,286.5C 241.755,284.967 240.755,282.967 240.5,280.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#b1b0b1",
    d: "M 244.5,281.5 C 246.266,285.239 247.099,289.239 247,293.5C 245.093,291.544 243.926,289.21 243.5,286.5C 243.5,286.167 243.5,285.833 243.5,285.5C 244.434,284.432 244.768,283.099 244.5,281.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#f8f3f3",
    d: "M 230.5,311.5 C 226.665,311.417 222.998,312.083 219.5,313.5C 212.183,314.118 204.849,314.451 197.5,314.5C 200.913,306.472 203.579,298.139 205.5,289.5C 206.675,289.281 207.675,289.614 208.5,290.5C 215.854,297.521 223.187,304.521 230.5,311.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#c1c1c1",
    d: "M 233.5,281.5 C 236.711,286.915 239.711,292.582 242.5,298.5C 241.726,299.711 240.893,299.711 240,298.5C 238.223,295.941 236.723,293.274 235.5,290.5C 235.244,287.402 234.578,284.402 233.5,281.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#f8a7a8",
    d: "M 140.5,295.5 C 142.027,295.427 143.027,296.094 143.5,297.5C 141.973,297.573 140.973,296.906 140.5,295.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#f6b7b7",
    d: "M 177.5,311.5 C 181.548,311.395 185.548,311.728 189.5,312.5C 189.5,313.167 189.167,313.5 188.5,313.5C 184.64,313.192 180.974,312.525 177.5,311.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#e6494c",
    d: "M 219.5,313.5 C 212.404,315.177 205.071,315.843 197.5,315.5C 197.715,317.179 197.048,318.179 195.5,318.5C 195.66,316.847 196.326,315.514 197.5,314.5C 204.849,314.451 212.183,314.118 219.5,313.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#f36b6a",
    d: "M 152.5,342.5 C 155.152,342.41 157.485,343.076 159.5,344.5C 156.848,344.59 154.515,343.924 152.5,342.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#f9abac",
    d: "M 245.5,343.5 C 245.389,344.117 245.056,344.617 244.5,345C 242.527,345.495 240.527,345.662 238.5,345.5C 240.657,344.593 242.99,343.927 245.5,343.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#f9a6a6",
    d: "M 238.5,345.5 C 236.485,346.924 234.152,347.59 231.5,347.5C 233.515,346.076 235.848,345.41 238.5,345.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#f48587",
    d: "M 178.5,348.5 C 189.482,349.286 200.482,349.619 211.5,349.5C 211.5,349.833 211.5,350.167 211.5,350.5C 202.494,350.666 193.494,350.5 184.5,350C 182.292,349.809 180.292,349.309 178.5,348.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#fbc3c3",
    d: "M 228.5,347.5 C 223.17,349.667 217.503,350.667 211.5,350.5C 211.5,350.167 211.5,349.833 211.5,349.5C 217.178,348.915 222.845,348.249 228.5,347.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.282
    },
    fill: "#73787f",
    d: "M 235.5,355.5 C 230.402,356.957 225.069,357.624 219.5,357.5C 224.616,356.194 229.949,355.527 235.5,355.5 Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogoTacc);
export default __webpack_public_path__ + "static/media/LogoTacc.0b41d4fd007871ce9d9bfebf0f936ed1.svg";
export { ForwardRef as ReactComponent };